import React from 'react';
import classnames from 'classnames';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import styles from './styles.module.scss';

const Unit = ({
                text,
                icon = '',
                children = <div/>,
                customClassnames = '',
                customHeaderClassnames = '',
              }) => {

  return (
    <div className={classnames(styles.unit, customClassnames)}>
      {(text || icon) &&
        <div className={styles.headerContainer}>
          <div className={classnames(styles.header, customHeaderClassnames)}>
            {icon && <img src={toAbsoluteUrl(icon)} alt="icon" className={styles.icon}/>}
            {text && <div className={styles.text}>{text}</div>}
          </div>
        </div>
      }
      {children}
    </div>
  );
};

export default Unit;